var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('quillEditor',{attrs:{"options":_vm.computedEditorOptions},model:{value:(_vm.syncValue),callback:function ($$v) {_vm.syncValue=$$v},expression:"syncValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }